<template>
  <div class="box-container flex-column align-center cover">
    <div class="d-flex flex-row justify-center">
      <v-overlay class="d-flex flex-row justify-center" :value="overlay">
        <div class="d-flex flex-row justify-center">
          <v-progress-circular color="primary"
                               indeterminate
                               size="64"></v-progress-circular>
        </div>
        <div>
          Merci de patienter, en attente de connexion vers la plateforme de formation continue…
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"

export default {
  components: {},
  data () {
    return {
      overlay: true,
      hasBeenRedirected: false,
      context: {
        encryptedId: "",
        urlRedirect: ""
      }
    }
  },
  async mounted () {
    try {
      console.log("Debut de laraRedirection")

      this.context.encryptedId = this.$route.params.contactId

      if (localStorage.getItem('laraReturnUrl') != null) {
        this.context.urlRedirect = localStorage.getItem('laraReturnUrl')
      } else {
        this.context.urlRedirect = ""
      }

      console.log("URL de redirection: ", this.context.urlRedirect)

      if (this.$route.params.contactId != null) {
        this.getLaraRedirectionLink(this.context)
            .then((response) => {
              if (response.data) {
                this.redirect(response.data)
              }
            })
            .catch((err) => {
              const messageErreur = "Une erreur est survenue lors de la connexion.<br/>Merci de bien vouloir essayer ultérieurement."
              if (err.response.status >= 500) {
                this.$router.push({ name: "InternalError", params: { message: messageErreur } })
              } else {
                this.getErrorLara(this.context)
                    .then((response) => {
                      if (response.data) {
                        this.$router.push({ name: "InternalError", params: { message: response.data } })
                      } else {
                        this.$router.push({ name: "InternalError", params: { message: messageErreur } })
                      }
                    })
              }
            })
      }
    } catch (erreur) {
      console.log(erreur)
    }
  },
  methods: {
    ...mapActions({
      getLaraRedirectionLink: "Lara/getLaraRedirectionLink",
      getErrorLara: "Lara/getErrorLara"
    }),
    redirect (link) {
      if (this.hasBeenRedirected == false) {
        if (this.context.urlRedirect) {
          window.location.replace(link)
        } else {
          window.top.location.replace(link)
        }
        this.hasBeenRedirected = true
      }
    }
  }
}
</script>